import { useState } from 'react'
import { Link, useParams } from 'react-router'
import { api } from '../api/client'
import { AuthCard } from '../components/AuthCard'
import { PasswordForm } from '../components/PasswordForm'

export function ResetPasswordScreen() {
	const { token } = useParams()
	const [done, setDone] = useState(false)
	if (done) {
		return (
			<AuthCard title="Password updated">
				<p>
					<Link to="/login">Sign in with your new password</Link>
				</p>
			</AuthCard>
		)
	}
	return (
		<AuthCard title="Choose a new password">
			<PasswordForm
				submitLabel="Update password"
				onSubmit={async ({ password }) => {
					await api.post('/api/auth/reset-password', { token, password })
					setDone(true)
				}}
			/>
		</AuthCard>
	)
}
